import script from "./Summary.vue?vue&type=script&lang=ts&setup=true"
export * from "./Summary.vue?vue&type=script&lang=ts&setup=true"

import "./Summary.vue?vue&type=style&index=0&id=39152c74&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39152c74"]])

export default __exports__